import React from "react";

export default function ProcurementDashboard() {
  return (
    <div>
      <h2>ProcurementDashboard</h2>
      <p>Coming Soon...</p>
    </div>
  );
}